import e from"react";import t from"../../../external/classnames/index.js";const a=({text:a,url:r,className:s,...m})=>e.createElement("a",{className:t("text-link",s),href:r,...m},a);export{a as TextLink};
//# sourceMappingURL=TextLink.js.map
